"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoading = exports.StyledBox = exports.StyledTreeItem = exports.StyledTree = exports.StyledTreeWrapper = exports.StyledCaption = exports.StyledTitle = exports.StyleAccordionDetails = exports.StylesAccordionSummary = exports.StyledAccordion = exports.StyledArrowForwardIosSharp = void 0;
const ui_components_1 = require("@groupby/ui-components");
const ArrowForwardIosSharp_1 = __importDefault(require("@mui/icons-material/ArrowForwardIosSharp"));
const material_1 = require("@mui/material");
const x_tree_view_1 = require("@mui/x-tree-view");
const styled_components_1 = __importStar(require("styled-components"));
const generic_1 = require("../../../../generic");
const { primaryGreen500, primaryBlueMed200, white } = ui_components_1.baseColors;
exports.StyledArrowForwardIosSharp = (0, styled_components_1.default)(ArrowForwardIosSharp_1.default) `
  transform: rotate(90deg);
  fill: ${white};
`;
exports.StyledAccordion = (0, styled_components_1.default)(material_1.Accordion) `
  && {
    &.MuiAccordion-root {
      max-width: ${({ theme }) => theme.spacing(100)};
    }
  
    & .MuiAccordionSummary-root {
      height: 2.25rem;
      min-height: 2.25rem;
    }
  }
`;
exports.StylesAccordionSummary = (0, styled_components_1.default)(material_1.AccordionSummary) `
  background-color: ${primaryGreen500};
  color: white;
  font-size: 0.75rem;
`;
exports.StyleAccordionDetails = (0, styled_components_1.default)(material_1.AccordionDetails) `
  background-color: ${primaryBlueMed200};
  display: flex;
  flex-wrap: wrap;
  gap: 1.87rem 1.25rem;
  max-height: 22.5rem;
  overflow-y: auto;
`;
exports.StyledTitle = styled_components_1.default.span `
  text-transform: uppercase;
`;
exports.StyledCaption = (0, styled_components_1.default)(ui_components_1.Typography) `
  font-style: italic;
`;
exports.StyledTreeWrapper = (0, styled_components_1.default)(material_1.Paper) `
  margin: ${({ theme }) => theme.spacing(1.25, 0, 3, 0)};
  padding: ${({ theme }) => theme.spacing(1.25)};
  width: ${({ theme }) => theme.spacing(45.625)};
`;
exports.StyledTree = (0, styled_components_1.default)(x_tree_view_1.SimpleTreeView) `
  overflow: auto;
  max-height: ${({ $listExpanded, theme: { spacing }, $productsCount }) => ($listExpanded ? ($productsCount > 6 ? spacing(31.25) : spacing(55.625)) : spacing(66))};

  &.MuiSimpleTreeView-root {
    margin: ${({ theme }) => theme.spacing(2.5, 0, 2.5, 2.5)};
  }

  .MuiTreeItem-label {
    padding: ${({ theme }) => theme.spacing(0.625)};
    font-size: 0.875rem;
  }

  & > li > div.MuiTreeItem-content {
    .MuiTreeItem-label {
      font-size: 1rem;
      text-transform: uppercase;
    }
  }
`;
exports.StyledTreeItem = (0, styled_components_1.default)(x_tree_view_1.TreeItem) `
  ${({ $hasChildren }) => !$hasChildren && (0, styled_components_1.css) `
    background-color: ${ui_components_1.baseColors.background100};
  `}

  .MuiTreeItem-group {
    margin-left: ${({ theme }) => theme.typography.pxToRem(7)};
    padding-left: ${({ theme }) => theme.spacing(3)};
    border-left: ${({ theme }) => theme.typography.pxToRem(1)} solid ${ui_components_1.baseColors.primaryBlueMed100};
  }

  .MuiTreeItem-iconContainer:empty {
    margin-right: 0;
    width: 0;
  }

  &.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label {
    background-color: transparent;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;
exports.StyledBox = (0, styled_components_1.default)(ui_components_1.Box) `
  display: flex;
  flex-direction: column;
`;
exports.StyledLoading = (0, styled_components_1.default)(generic_1.Loading) `
  flex-basis: 100%;
`;
